<template>
  <div class="bottom-container">
    <div class="bottom">
      <div class="box left-box">
        <div class="title">怡福科技 · Yifu</div>
        <div class="iphone">
          <div class="ip1">产品服务咨询热线：</div>
          <div class="ip2">+86 180 0273 3332</div>
        </div>
      </div>
      <div class="box center-box">
        <div class="title">联系我们</div>
        <div class="content">
          <div>电话：(+86) 18002733332</div>
          <div>邮箱：yifu@yifudj.com</div>
          <div>地址：东莞市松山湖总部一路6号</div>
        </div>
      </div>
      <div class="box right-box">
        <div class="right-box-img">
          <img src="@/assets/img/kefu.jpg" alt="" />
          <div class="title">客服微信</div>
        </div>
        <div class="right-box-img">
          <img src="@/assets/img/official_account.jpg" alt="" />
          <div class="title">公众号二维码</div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div>ICP备案号：<a href="https://beian.miit.gov.cn">粤ICP备2025432719号</a> - © 2025 yifu.com All Rights Reserved. 广东怡福科技有限公司</div>
      <div>版权所有：广东怡福科技有限公司</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Bottom",
  data() {
    return {
      name: "底部栏",
    };
  },
  mounted() {
    console.log("MyComponent mounted"); // 输出：MyComponent mounted
  },
};
</script>

<style lang="less" scoped>
a {
    // text-decoration: none; /* 去除下划线 */
    color: inherit;       /* 继承父元素文字颜色，避免蓝色 */
}

.bottom-container {
  margin: 0;
  padding: 0;
  overflow: hidden;
  box-sizing: border-box;
  background-color: #333333;
}

.bottom {
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  padding: 10px 50px;
  box-sizing: border-box;

  .box {
    height: calc(100% - 20px);
    flex: 1;
    margin: 20px 10px;
    padding: 0 20px;
  }

  .left-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;

    .title {
      font-size: 18px;
      font-weight: bold;
      color: #ffffff;
      margin-bottom: 30px;
    }

    .iphone {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;

      .ip1 {
        font-size: 12px;
        color: #dfdfdf;
        margin-bottom: 10px;
      }

      .ip2 {
        min-width: 175px;
        font-size: 20px;
        font-weight: bold;
        color: rgb(26, 158, 101);
      }
    }
  }

  .center-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    font-size: 12px;

    .title {
      font-size: 18px;
      color: #ffffff;
      margin-bottom: 15px;
    }

    .content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      width: 100%;
      height: auto;

      div {
        min-width: 170px;
        width: 100%;
        height: 20px;
        margin-bottom: 5px;
        text-align: left;
        color: #c0c0c0;
      }
    }
  }

  .right-box {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;

    .right-box-img {
      img {
        width: 100px;
        height: 100px;
      }

      .title {
        color: #d2d2d2;
        margin-top: 6px;
        letter-spacing: 2px;
      }
    }
    .right-box-img:first-child {
      margin-right: 30px;
    }
  }
}

.footer {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  color: #d2d2d2;
  font-size: 12px;
  padding: 0 20px;
  box-sizing: border-box;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/home/components/Bottom.vue